import Section from 'layouts/Section/Section';

import ResponsiveCarousel from 'components/ResponsiveCarousel/ResponsiveCarousel';
import Title from 'components/Title/Title';

import { useMobileDesign } from 'hooks/useMobileDesign';

import LeaderCard from './Card';
import config from './config';
import styles from './styles.module.scss';

const ClientCards = () => {
  const isMobile = useMobileDesign(992);

  return (
    <Section background="--brand-primary-lighten">
      <Title title="Our Leadership Team">
        Our innovative global leaders are focused on achieving our shared vision
        of ethical recruitment, empowering job seekers and employers while
        promoting integrity in the hiring process.
      </Title>
      {isMobile ? (
        <ResponsiveCarousel
          responsive={[{ breakpoint: 620, settings: { slidesToShow: 1 } }]}
        >
          {config.map((leader, index) => (
            <LeaderCard
              key={index}
              name={leader.name}
              title={leader.title}
              bio={leader.bio}
              image={leader.image}
            />
          ))}
        </ResponsiveCarousel>
      ) : (
        <div className={styles.cardContainer}>
          {config.map((leader, index) => (
            <LeaderCard
              key={index}
              name={leader.name}
              title={leader.title}
              bio={leader.bio}
              image={leader.image}
            />
          ))}
        </div>
      )}
    </Section>
  );
};

export default ClientCards;
